<!-- Dialog for adding a study table record -->
<mat-dialog-content class="mat-typography" style="color:#003865">

    <h1>Add New Study</h1>

        <!-- Study name -->
        <!-- Required field -->
        <div>
          <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>Study name (max 50 characters)</mat-label>
            <input matInput [(ngModel)]="studyName" (ngModelChange)="verifyFormSubmission()" required>
          </mat-form-field>
          <!-- Study name error, if length exceeds 50 characters -->
          <p *ngIf="studyName?.length > 50" style='color:red'>Your study name has {{studyName.length}} characters, please modify to be no more than 50 characters.</p>
        </div>

        <!-- Study remarks -->
        <div>
          <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>Remarks (max 255 characters)</mat-label>
            <input matInput [(ngModel)]="studyRemarks">
          </mat-form-field>
          <!-- Study remarks error, if length exceeds 255 characters -->
          <p *ngIf="studyRemarks?.length > 255" style='color:red'>Your remarks have {{studyRemarks.length}} characters, please modify to be no more than 255 characters.</p>
        </div>

        <!-- Study date -->
        <!-- Required field -->
        <div>
          <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>Study date</mat-label>
            <input matInput [matDatepicker]="picker" required  [(ngModel)]="studyDate" (ngModelChange)="verifyFormSubmission()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Vertical Datum -->
        <!-- Required field -->
        <!-- Note: The service requires coded values -->
        <div>
          <mat-form-field appearance="fill">
            <mat-label>Vertical datum</mat-label>
            <select matNativeControl required  [(ngModel)]="verticalDatum" (ngModelChange)="verifyFormSubmission()">
              <option value=null></option>
              <option value="8">Assumed</option>
              <option value="9">Local</option>
              <option value="11">GAGE Hgt</option>
              <option value="12">NGVD 29</option>
              <option value="13">NAVD 88</option>
              <option value="14">MSL 1912</option>
            </select>
          </mat-form-field>
        </div>

        <!-- Source Type -->
        <!-- Note: The service requires coded values -->
        <div>
          <mat-form-field appearance="fill">
            <mat-label>Source type</mat-label>
            <select matNativeControl  [(ngModel)]="sourceType">
              <option value=null></option>
              <option value="1">FEMA - FIS</option>
              <option value="2">FEMA - LOMR</option>
              <option value="3">FEMA - Zone A - Tier 3</option>
              <option value="4">DNR - NFIP Coordinator Memo</option>
              <option value="5">DNR - DNR Memo</option>
              <option value="6">DNR - DNR Study Report</option>
              <option value="7">DNR - Local</option>
              <option value="8">Federal Non-FEMA - Study</option>
              <option value="9">Federal Non-FEMA - Project</option>

            </select>
          </mat-form-field>
        </div>

</mat-dialog-content>

<!-- Error message for the user if the submission button is disabled -->
<mat-dialog-actions align="center">
  <p *ngIf="formSubmission === false" style="color:red;font:400 14px/20px sans-serif">Please enter the required fields, marked with an asterisk (*), and ensure you meet the character limits.</p>
</mat-dialog-actions>

<mat-dialog-actions align="end">
    <!-- Submit new study button -->
    <button mat-raised-button color="primary" [disabled]="formSubmission === false ? true : null" (click)="addStudy()" mat-dialog-close>Submit</button>
    <!-- Close button -->
    <button mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>
